import { render, staticRenderFns } from "./QuoteListVersions.vue?vue&type=template&id=79e40056&scoped=true"
import script from "./QuoteListVersions.vue?vue&type=script&lang=js"
export * from "./QuoteListVersions.vue?vue&type=script&lang=js"
import style0 from "./QuoteListVersions.vue?vue&type=style&index=0&id=79e40056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e40056",
  null
  
)

export default component.exports